const my_profile = {
  viewMyClubSeacretProfile: "Voir mon profil ClubSeacret", // translated
  unverifiedEmail: "E-mail non vérifié", // translated
  viewMoreDetails: "Afficher plus de détails", // translated
  verifiedEmail: "E-mail vérifié", // translated
  createdFrom: "Créé à partir de", // translated
  createdTo: "Créé jusqu'à", // translated
  selectStatus: "Sélectionner le statut...", // translated
  searchByTitle: "Rechercher par titre...", // translated
  pushNotifications: "Notifications push", // translated 
  pushNotificationsDescription: "Recevoir des notifications du navigateur pour les mises à jour et événements importants", // translated 
  pushNotificationsNotSupported: "Les notifications push ne sont pas prises en charge dans ce navigateur", // translated 
  pushNotificationsDeniedMessage: "L'autorisation de notification a été refusée. Veuillez activer les notifications dans les paramètres de votre navigateur pour recevoir des notifications push.", // translated 
  pushNotificationsEnabled: "Notifications push activées avec succès", // translated 
  pushNotificationsDisabled: "Notifications push désactivées avec succès", // translated 
  userInformationMissing: "Les informations utilisateur sont manquantes", // translated 
  failedToUpdatePushNotifications: "Échec de la mise à jour des paramètres de notifications push", // translated 
  notificationPermissionDenied: "L'autorisation de notification a été refusée. Veuillez l'activer dans les paramètres de votre navigateur.", // translated 
  notificationPermissionRequired: "L'autorisation de notification est requise pour activer les notifications push", // translated 
  notSupported: "Non pris en charge", // translated 
  permissionDenied: "Autorisation refusée", // translated 
  permissionNotRequested: "Autorisation non demandée", // translated 
  enabled: "Actif", // translated 
  disabled: "Désactivé", // translated 
};


export default my_profile;
